import React, { createContext, useContext, useState, useEffect } from "react";
import Axios from "../_services/caller.service";
import NavContext from "../context/NavContext";
import LoaderLogin from "../components/UiComponents/loader/LoaderLogin";

const PermissionsContext = createContext({});
export const usePermissionsContext = () => useContext(PermissionsContext);

export function PermissionsProvider({ children }) {
  const { userAuth, ownerId, user, superAdmin,realOwnerId } = useContext(NavContext);
  const [permissions, setPermissions] = useState(null); // null = loading

useEffect(() => {
  

  if (userAuth === false) {
    // console.warn("⛔️ Utilisateur non authentifié → permissions non chargées");
    // console.groupEnd();
    return;
  }

  let cancelled = false;

  async function fetchPermissions() {
    try {
  console.log("🔄 Fetch permissions for ownerId", ownerId);
  console.log("🔄 Fetch permissions for realownerId", realOwnerId);
      const res = await Axios.get(`/getEffectivePermissions/${realOwnerId}`);
   

      const received = res.data;
      const perms =
        received.permissions && typeof received.permissions === "object"
          ? received.permissions
          : received;

      if (!cancelled) {
        setPermissions({ superAdmin, permissions: perms });

      }
    } catch (err) {
      console.error("❌ Erreur fetch permissions :", err);
      if (!cancelled) {
        setPermissions({ superAdmin, permissions: {} });
      }
    } finally {
      console.groupEnd();
    }
  }

  fetchPermissions();

  return () => {
    cancelled = true;
    // console.log("🧹 Cleanup → annulation fetch permissions");
  };
}, [userAuth, ownerId, superAdmin, realOwnerId]);



  if (permissions === null) {
  //  console.log("⌛️ Chargement des permissions en cours...");
    return <LoaderLogin />;
  }

  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
}
